import { PageContainer } from "@swot/base-components";
import { CmtsApiErrorPanel } from "../CmtsApiErrorPanel.js";
import { CmtsEvidenceRecord } from "@modules/core/complaints/cmtsComplaintLifecycleTypes.js";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CmtsEvidenceUploader } from "./CmtsEvidenceUploader.js";
import { CmtsEvidenceList } from "./CmtsEvidenceList.js";
import { CmtsEvidencePreviewPanel } from "./CmtsEvidencePreviewPanel.js";
import { evidenceApi } from "@modules/services/evidenceApi.js";

export function CmtsEvidencePanel() {
  const complaintId = useParams<{ complaintId: string }>().complaintId ?? "";
  const list = useQuery({ queryKey: ["cmts", "backend-evidence", complaintId], queryFn: ({ signal }) => evidenceApi.list(complaintId, signal), enabled: Boolean(complaintId), retry: 1 });
  const [previewRow, setPreviewRow] = useState<CmtsEvidenceRecord | null>(null);
  if (!complaintId) return <PageContainer title="Evidence"><CmtsApiErrorPanel error={new Error("missing_route_param: complaintId is required for evidence.")} /></PageContainer>;
  return (
    <PageContainer title="Evidence" subtitle="Backend evidence upload, tokenized download, deactivate and delete flow.">
      {list.error ? <CmtsApiErrorPanel error={list.error} title="Evidence backend list failed" onRetry={() => void list.refetch()} /> : null}
      <CmtsEvidenceUploader complaintId={complaintId} onUploaded={async () => { await list.refetch(); }} />
      <CmtsEvidenceList complaintId={complaintId} rows={list.data ?? []} onPreview={setPreviewRow} />
<CmtsEvidencePreviewPanel complaintId={complaintId} row={previewRow} onClose={() => setPreviewRow(null)} />    </PageContainer>
  );
}